import { useCallback } from 'react';
import domToImage from 'dom-to-image';
import jsPDF from 'jspdf';

interface UseDownloadPDFProps {
  ref: React.RefObject<any>;
  name: string;
}

export const useDownloadPDF = ({ ref, name }: UseDownloadPDFProps) => {
  const downloadPDF = useCallback(async () => {
    const gridContainer = ref.current;
    if (gridContainer) {
      const inner = gridContainer.getGridRef();
      const gridElement = inner && inner.current;
      if (gridElement) {
        const oldStyles = gridElement.style;
        gridElement.style.margin = '0';
        // Capture the grid as a canvas
        const imageData = await domToImage.toPng(gridElement);
        gridElement.style = oldStyles;
        const image = new Image();
        image.src = imageData;
        image.onload = () => {
          // Create a PDF
          const pdf = new jsPDF('p', 'mm', 'a4');
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (image.height * pdfWidth) / image.width;

          pdf.addImage(imageData, 'PNG', 0, 0, pdfWidth, pdfHeight);
          pdf.save(`${name}_export_${new Date().toDateString()}.pdf`);
        };
      }
    }
  }, [ref, name]);

  return { downloadPDF };
};
